module.exports = __webpack_public_path__ + "img/4_120.8b5b6c90.png";